'use strict';

/**
 * Swaps the order of the arguments to a function.
 *
 * @param {Function} f The function.
 * @returns {Function} A new function which calls `f` with the arguments swapped.
 * @example
 *
 * import { flip } from 'fkit'
 * function f (a, b) { ... }
 * const g = flip(f)
 * g(1, 2) // f(2, 1)
 */
function flip(f) {
  return function (a, b) {
    return f(b, a);
  };
}

module.exports = flip;
